
export default {
  name: "cert"
};
